<div class="search-filter-sort-bar flex-direction">
  <div class="search-sort-bar">
    <div class="section">
      <div class="search-pagination-row">
        <div class="search-box">
          <img width="15" src="assets/gray-search-icon.png" alt="search icon" class="search-icon" (click)="search()">
          <input (input)="searchRealTime()" (keyup.enter)="search()" [(ngModel)]="param" placeholder="Search"
            id="userInput">
          <img width="30" src="assets/clear-icon.svg" alt="clear icon" class="clear-icon" id="clear" (click)="clear()">
        </div>
      </div>

      <div class="filter-icon" (click)="toggleDropdown()">
        <div class="filter-img"><img width="25" src="assets\filter.png" alt="filter icon"></div>
        <div class="filter-trigger">Filters</div>
      </div>
    </div>

    <div class="section">
      <div id="opportunity-type" class="search-filter-sort-bar-dropdown">
        <div class="dropdown-heading">Display:</div>
        <mat-select [(value)]="selectedMetricOption" [disableOptionCentering]="true" class="select-box"
          (selectionChange)="onSelectionChange($event)">
          <mat-option [disabled]="option.isStatic" *ngFor="let option of dropdownOptions; let i = index"
            [value]="option.value" [ngClass]="{'indent-option': i > 1}">
            <div class="search-filter-sort-bar-dropdown-option">
              <img *ngIf="option.image" [src]="option.image" alt="option.text" class="option-image" />
              <span>{{ option.text }}</span>
            </div>
          </mat-option>
        </mat-select>
      </div>

      <div id="sort-bar" class="search-filter-sort-bar-dropdown">
        <div class="dropdown-heading">Sort By:</div>
        <mat-select id="sortDropdown" (selectionChange)="onSortChange($event)" class="select-box"
          [(value)]="selectedSortOption">
          <mat-option [value]="'amount'">
            <div class="search-filter-sort-bar-dropdown-option">
              <span>Amount of Impact</span>
            </div>
          </mat-option>
          <mat-option [value]="'location'">
            <div class="search-filter-sort-bar-dropdown-option">
              <span>Number of Locations</span>
            </div>
          </mat-option>
          <mat-option [value]="'difficulty'">
            <div class="search-filter-sort-bar-dropdown-option">
              <span>Level of Difficulty</span>
            </div>
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <mat-paginator [length]="length" [pageSize]="pageSize" (page)="page.emit($event)" [pageIndex]="pageIndex">
  </mat-paginator>
</div>
<div id="filterDropdown">
  <div class="filter-container">
    <div class="filter-section">
      <label class="label">Total Value Delivered Metrics</label>
      <div class="checkboxes-list">
        <label class="option" *ngFor="let option of filterConfig.tvd">
          <input type="checkbox" [(ngModel)]="filterOptions[option]" [value]="option"
            (change)="updateFilterOptions(option)">{{ option }}
        </label>
      </div>
    </div>
    <div class="filter-section">
      <label class="label">Solution Category</label>
      <div class="checkboxes-list">
        <label class="option" *ngFor="let option of filterConfig.solutionCategory">
          <input type="checkbox" [(ngModel)]="filterOptions[option]" [value]="option"
            (change)="updateFilterOptions(option)">{{ option }}
        </label>
      </div>
    </div>
    <div class="filter-section" *ngIf="inMyActions">
      <label class="label">Timing</label>
      <div class="checkboxes-list">
        <label class="option" *ngFor="let option of filterConfig.actionStatus">
          <input type="checkbox" [(ngModel)]="filterOptions[option]" [value]="option"
            (change)="updateFilterOptions(option)">{{ option }}
        </label>
      </div>
    </div>
  </div>
  <div class="reset-apply">
    <div class="reset-btn" (click)="resetCheckboxes()">Reset</div>
    <div class="apply-btn">
      <button class="button-blue" (click)="applyActionDataFilters()">Apply</button>
    </div>
  </div>
</div>